export default __webpack_public_path__ + "static/media/edit-location-cancel.7dbdb571.svg";